

import React, { FunctionComponent, useState, useEffect } from 'react';
import styles from './styles.module.css'
import { AppSwitcherIcon, ChangePwdIcon } from './icons'
import cognitoUtils from './lib/cognitoUtils';


export const AppManagerTopBar: FunctionComponent = (props: any) => {
    const [appSwitcherVisible, setAppSwitcherVisibility] = useState(false);
    const [appLogoutVisible, setAppLogoutVisibility] = useState(false);
    const [apps, setApps] = useState<Array<any>>([])

    document.onclick = (e: any) => {
        if(e && e.target && e.target.classList && !e.target.classList.contains('app__manager_btn') ) {
            setTimeout(() => {
                setAppLogoutVisibility(false);
                setAppSwitcherVisibility(false);
            })
        }
    }

    const toggleSwitcher = (value: boolean): void => {
        setAppSwitcherVisibility(value);
        setAppLogoutVisibility(false)
    }

    const toggleLogout = (value: boolean): void => {
        setAppLogoutVisibility(value)
        setAppSwitcherVisibility(false);
    }

    const resetPwd = () => {
        document.location.href = `${props.config.userPoolBaseUri}/forgotPassword?response_type=code&client_id=${props.config.clientId}&redirect_uri=${props.config.callbackUri}`
    }

    const switchApp = url => {
        document.location.href = url;
    }

    const simplifyUrl = url => url.replace(/[^a-zA-Z0-9]/g, '').replace('https', '').replace('http', '')

    useEffect(() => {
        fetch(props.config.appsConfigUrl).then(response => response.json() ).then(apps => {
            setApps(apps.apps);
            const current = simplifyUrl(document.location.href);
            // const current = simplifyUrl('https://users.smartbrandscompany.com');
            for(let app of apps.apps) {
                if(simplifyUrl(app.url) === simplifyUrl(current) ) {
                    let session = localStorage.getItem('session');
                    if(session) {
                        const parsed = JSON.parse(session);
                        if(app.role && app.role.length > 0) {
                            for(let role of app.role) {
                                if(!parsed.user['cognito:groups']) document.location.href = 'https://central.smartbrandscompany.com';
                                 if(parsed.user['cognito:groups'].find(group => role === group) ) {
                                    return;
                                 }
                            }
                            document.location.href = 'https://central.smartbrandscompany.com';
                        }
                        
                    }
                }
            }
        })
    }, [])

    return (
        <div className={styles.app__manager_bar}>
            <div className={styles.app__manager_switch_ra}>
                <a href="#" onClick={() => toggleSwitcher(!appSwitcherVisible)} className={`${styles.app__manager_switch} app__manager_btn app__manager-switch`}><AppSwitcherIcon /></a>
                <a href="#" onClick={() => toggleLogout(!appLogoutVisible)} className={`${styles.app__manager_logout} app__manager_btn app__manager-logout`}>
                    <img className="app__manager_btn" alt="" src="http://www.gravatar.com/avatar/46803efb190ffa0cc05db29e1b4da92f?d=mp&amp;r=g&amp;s=50" />
                </a>
            </div>
            
            {appSwitcherVisible && (
                <div className={styles.app__manager_switch_container}>
                    <ul className={styles.app__manager_apps}>
                        {apps.map((app, i) => 
                            props['cognito:groups'].filter(itm => app.role.includes(itm) ).length > 0 ?
                            <li key={`app_manager-index-${i}`} onClick={() => switchApp(app.url) }>
                                <img style={{ width: '30px'}} alt="" width="120" src={app.logoURL} />
                                {app.name}
                            </li>
                            : null
                        )}
                    </ul>
                </div>
            )}

            {appLogoutVisible && (
                <div className={styles.app__manager_logout_container}>
                    <ul className={styles.app__manager_list}>
                        <li onClick={resetPwd}>
                            <ChangePwdIcon />
                            Change Password
                        </li>
                        <li>
                            <button onClick={() => cognitoUtils.signOutCognitoSession(props.config)} className={styles.logout__btn}>Sign Out</button>
                        </li>
                    </ul>
                </div>
            )}
        </div>
    )
}
